// extracted by mini-css-extract-plugin
module.exports = {"save":"index_save_33r4Y","cancel":"index_cancel_1p5E9","display":"index_display_ozIRC","leveldiv":"index_leveldiv_cu-8v","totaldiv":"index_totaldiv_o3oIt"};